import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'

const boughtQuery = () => {
  const data = useStaticQuery(graphql`
      query BoughtStaticQuery {
        allWpBought {
          nodes {
            slug
            title
            date
            acf {
              featuredImage {
                localFile {
                  publicURL
                }
              }
              price
              specs {
                bath
                bed
                car
              }
              testimonial
              weblink
            }
          }
        }
      }
    `)

  return data
}

export default boughtQuery